import {storage} from "@/firebase"

const uploadImg = async (idSolutions, file) => {
    try {
        const imgNameSaved = new Date().getTime()
        const pathSaved = `solutions/${idSolutions}/${imgNameSaved}`
        const storageWS_REF = storage.ref(pathSaved)
        var task = storageWS_REF.put(file);
        await new Promise((resolve, reject) => {
            task.on('state_changed',
                function progress(snapshot) {
                    var percentage = snapshot.bytesTransferred / snapshot.totalBytes * 100;
                },
                function error(err) {
                    console.error(`uploadImg - ${err}`)
                    reject(err)
                },
                function complete() {
                    var downloadURL = task.snapshot.downloadURL;
                    resolve("Download Complet")
                }
            );
        })
        return pathSaved
    } catch (error) {
        console.error("uploadImg ",error)
    }
}

const downloadImg = async (path) => {
    try {
        const fileRef = storage.ref(path);
        const downloadURL = await fileRef.getDownloadURL();
        const response = await fetch(downloadURL);
        const blob = await response.blob();
        return blob;
    } catch (error) {
        console.error(error)
    }
}
const deleteImg = async (path) => {
    try{
        await storage.ref(path).delete()
    }catch(err){
        console.error(`Error - deleteImg ${err}`)
    }
}

export default {
    uploadImg,
    deleteImg,
    downloadImg
}